// QUESTION: what's the point of this file? it seems to be for the rare cases
// where we need a global hard-coded element identifier

export const DIAGRAM_ENGINE_CANVAS = "PhotonEngineCanvas";
export const DIAGRAM_ROOT_ELEMENT = "threeRootElement";
export const USER_PRESENCE_ELEMENT = "user_presence_element";

export const PCB_ROOT_ELEMENT = "PcbRootElement";
